export default function ContactUs() {
  return (
    <div className="min-h-screen py-12 px-6 font-sans text-gray-800" dir="rtl">
      <div className="max-w-4xl mx-auto bg-white p-8 rounded-xl shadow-md">
        {/* <h1 className="text-3xl font-bold text-green-700 mb-6 text-center">تماس با ما</h1> */}
        <p className="text-gray-600 text-center">صفحه تماس با ما به زودی راه‌اندازی خواهد شد.</p>
      </div>
    </div>
  );
}
